// extracted by mini-css-extract-plugin
export default {"objetGraphe":"ObjetGraphe_objetGraphe__1Yasr","FondImageGraphe":"ObjetGraphe_FondImageGraphe__G8DHj"};